import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import { ULoading, UTextField } from "@/components/index"
import { UButton } from "@/components/index"
import { setOpenUndercutPreview } from "@/UDTreat/udTreatSlice"
import { GlobalEvents, globalEvents, wasmModule } from "@/gluelayer"
import { IPrintSettingJsonObj } from "@/core/app/slices/user/user.type"
export const UndercutFill: React.FC<{
  jsonData?: IPrintSettingJsonObj
  updateJsonData: (data: IPrintSettingJsonObj) => void
}> = ({ jsonData, updateJsonData }) => {
  const {
    clinicalSettings: { UnderCut },
  } = useAppSelector((state: RootState) => state.userService)

  const { openUndercutPreview } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const dispatch = useAppDispatch()
  // checkbox if No UnderCut
  const [checkNoUnder, setCheckNoUnder] = useState<string>("")
  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckNoUnder((event.target as HTMLInputElement).value)
    updateJsonData({
      UnderCut: (event.target as HTMLInputElement).value === "1" ? 1 : 0,
    })
  }
  const [isloading, setIsloading] = useState(false)

  useEffect(() => {
    if (!jsonData) return
    setCheckNoUnder(jsonData.UnderCut === 1 ? "1" : "0")
  }, [jsonData])
  // udercut radio to wasm
  useEffect(() => {
    try {
      const printModule = wasmModule.moduleManager.GetModulePrintSelection()
      if (!printModule) return
      printModule.SetUnderCutEnable(+checkNoUnder === 0 ? true : false)
    } catch (error) {
      console.log(error)
    }
  }, [checkNoUnder])
  return (
    <Box sx={{ width: "100%" }}>
      {/* <FormControlLabel
        control={<Checkbox checked={checkNoUnder} onChange={handleCheck} />}
        label="Do not add undercut filling(digital waxing)"
        sx={{ margin: "0 0 10px 0" }}
      /> */}
      <FormControl>
        <FormLabel id="addUnderCut">{`Add undercut filling(digital waxing)`}</FormLabel>
        <RadioGroup
          row
          sx={{ marginLeft: "10px", gap: "40px" }}
          aria-labelledby="addUnderCut"
          name="radio-buttons-group"
          value={checkNoUnder}
          onChange={handleCheck}
        >
          <FormControlLabel value={"0"} control={<Radio />} label="Yes" />
          <FormControlLabel value={"1"} control={<Radio />} label="No" />
        </RadioGroup>
      </FormControl>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "start",
          marginTop: "24px",
        }}
      >
        <UButton
          sxProp={{
            color: "#212121",
            height: "36px",
            width: "176px",
            borderRadius: "4px",
            background: "#DADCDD !important",
            boxShadow:
              "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)",
            padding: "6px 16px",
          }}
          variant={"contained"}
          btnText={`Digital fill Preview`}
          disabled={ Number.parseInt(checkNoUnder) > 0}
          onClickHandler={() => {
            const printModule =
              wasmModule.moduleManager.GetModulePrintSelection()
            if (!printModule) return

            if (!openUndercutPreview) {
              setIsloading(true)
              setTimeout(() => {
                ;(window as any).setUBRefreshUICBStr = () => {
                  console.log("SetUBRefreshUICBStr")
                  globalEvents.fire(GlobalEvents.ON_UBRefreshUICBStr)
                }
                ;(window as any).setUBHandleCancleSelectCBStr = () => {
                  console.log("SetUBHandleCancleSelectCBStr")
                  globalEvents.fire(GlobalEvents.ON_UBHandleCancleSelectCBStr)
                }

                printModule.SetUBRefreshUICBStr("window.setUBRefreshUICBStr()")
                printModule.SetUBHandleCancleSelectCBStr(
                  "window.setUBHandleCancleSelectCBStr()",
                )

                printModule.OnUndercutPreviewButtonDown()
                dispatch(setOpenUndercutPreview(true))
                setIsloading(false)
              }, 200)
            } else {
              printModule.ApplyInPreview()
              printModule.GoToOrigin3DScene()
              dispatch(setOpenUndercutPreview(false))
            }
          }}
        />
      </Box>
      <ULoading isLoading={isloading} />
    </Box>
  )
}
